<template>
  <div class="header">
    <div class="headerbox" v-if="$store.state.chackchannel == 1">
      <div class="hd" v-if="lang == 'en'">
        <img @click="tzindex" :src="headlogo" alt="" />
        <ul class="boxul">
          <li class="boxulli" v-for="(a, b) in showlists" :key="b + '*'">
            <p class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }" v-if="a.id == 16">
              <router-link :to="{ path: '/', query: { lang: a.langName } }">{{
                a.name
              }}</router-link>
            </p>
            <p v-else-if="a.id == 19" class="boxlit" :class="{ boxlitactive: boxlitactiveid == 19 }">
              <router-link :to="{
                  name: 'aboutus',
                  query: { page: 17, id: 23, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <p v-else-if="a.id == 18" class="boxlit" :class="{ boxlitactive: boxlitactiveid == 18 }">
              <router-link :to="{
                  name: 'exhibtions',
                  query: { page: 18, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <p v-else class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }">
              <router-link :to="{
                  name: a.tzname,
                  query: { page: a.id, id: a.firstid, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <ul class="boxinul">
              <li v-for="(c, d) in a.children" :key="d + '_'">
                <router-link :to="{
                    name: c.tzname,
                    query: {
                      page: c.parentId,
                      id: c.id,
                      lang: $t('language.lang'),
                    },
                  }">{{ c.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div class="langchange">
          <h3 data-lang="en" @click="changeLang">EN</h3>
          <i></i>
          <h3 data-lang="cs" @click="changeLang">CN</h3>
          <!-- <img :src="$t('language.url')" alt="" /> -->
        </div>
      </div>
      <div class="hd" v-if="lang == 'cs'">
        <img @click="tzindex" src="/static/images/log1.png" alt="" />
        <ul class="boxul">
          <li class="boxulli" v-for="(a, b) in showlists" :key="b + '*'">
            <p class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }" v-if="a.id == 1">
              <router-link :to="{ path: '/', query: { lang: a.langName } }">{{
                a.name
              }}</router-link>
            </p>
            <p v-else-if="a.id == 4" class="boxlit" :class="{ boxlitactive: boxlitactiveid == 4 }">
              <router-link :to="{
                  name: 'aboutus',
                  query: { page: 2, id: 8, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <p v-else-if="a.id == 3" class="boxlit" :class="{ boxlitactive: boxlitactiveid == 3 }">
              <router-link :to="{
                  name: 'exhibtions',
                  query: { page: 3, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <p v-else class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }">
              <router-link :to="{
                  name: a.tzname,
                  query: { page: a.id, id: a.firstid, lang: a.langName },
                }">{{ a.name }}</router-link>
            </p>
            <ul class="boxinul">
              <li v-for="(c, d) in a.children" :key="d + '_'">
                <router-link :to="{
                    name: c.tzname,
                    query: {
                      page: c.parentId,
                      id: c.id,
                      lang: $t('language.lang'),
                    },
                  }">{{ c.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
        <div class="langchange">
          <h3 data-lang="en" @click="changeLang">EN</h3>
          <i></i>
          <h3 data-lang="cs" @click="changeLang">CN</h3>
          <!-- <img :src="$t('language.url')" alt="" /> -->
        </div>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="headerbox2" v-else>
      <div class="hd">
        <img src="/static/images/log1.png" @click="tzindex" class="log1" alt="" />
        <div class="btnbox">
          <div class="langchange">
            <!-- <img :src="$t('language.url')" alt="" /> -->
            <h3 data-lang="en" @click="changeLang">EN</h3>
            <i></i>
            <h3 data-lang="cs" @click="changeLang">CN</h3>
          </div>
          <div class="menubox" @click="showmenu()">
            <img src="/static/images/menu.png" alt="" />
          </div>
        </div>
      </div>
      <div class="menus" :class="{ menusshow: ismenus }">
        <ul class="boxul">
          <li class="boxulli" v-for="(a, b) in showlists" :key="b + '*'">
            <div class="flexdiv" @click="zk(b)">
              <p class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }" v-if="a.id == 16 || a.id == 1">
                <router-link :to="{ path: '/', query: { lang: a.langName } }" @click.native="gbceng()">{{ a.name }}</router-link>
              </p>
              <p v-else-if="a.id == 19 || a.id == 4" class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }">
                <router-link :to="{
                    name: 'aboutus',
                    query: {
                      page: $t('language.lang') == 'en' ? 17 : 2,
                      id: $t('language.lang') == 'en' ? 23 : 8,
                      lang: a.langName,
                    },
                  }" @click.native="gbceng()">{{ a.name }}</router-link>
              </p>
              <p v-else-if="a.id == 18 || a == 3" class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }">
                <router-link :to="{
                    name: 'exhibtions',
                    query: {
                      page: $t('language.lang') == 'en' ? 18 : 3,
                      lang: a.langName,
                    },
                  }" @click.native="gbceng()">{{ a.name }}</router-link>
              </p>
              <p v-else class="boxlit" :class="{ boxlitactive: boxlitactiveid == a.id }">
                <router-link :to="{
                    name: a.tzname,
                    query: { page: a.id, id: a.firstid, lang: a.langName },
                  }" @click.native="gbceng()">{{ a.name }}</router-link>
              </p>
              <i class="xl"></i>
            </div>
            <ul class="boxinul" v-show="showidx == b">
              <li v-for="(c, d) in a.children" :key="d + '_'">
                <router-link :to="{
                    name: c.tzname,
                    query: { page: c.parentId, id: c.id, lang: a.langName },
                  }" @click.native="gbceng()">{{ c.name }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      showlists: {},
      showidx: "",
      ismenus: false,
      pams: "",
      boxlitactiveid: "",
      lang: "",
      headlogo: '/static/images/log1.png'
    };
  },
  created () { },
  watch: {
    $route: function (val) {
      let pams = this.$route.query;
      console.log(pams, "头部监听获得");
      if (pams.page) {
        this.boxlitactiveid = pams.page;
      } else {
        if (pams.lang == "cs") {
          this.boxlitactiveid = 1;
        } else {
          this.boxlitactiveid = 16;
        }
      }
      let lang = "";
      if (pams.lang) {
        lang = pams.lang;
      } else {
        lang = "en";
      }
      this.$i18n.locale = lang; //改变当前语言
      localStorage.locale = lang;
      this.pams = pams;
      this.lang = lang;
      this.getmenus(lang);
      this.getlogpic(lang);
    },
  },
  methods: {
    // 获取目录
    getmenus (a) {
      let that = this;
      that.axios
        .post("/index/index/home_nav", { lang: a })
        .then(function (res) {
          let data = res.data;
          if (data.status == 200) {
            let databox = data.msg;
            for (let k in databox) {
              if (databox[k].children.length > 0) {
                databox[k].firstid = databox[k].children[0].id;
              } else {
                databox[k].firstid = "a";
              }
            }
            console.log(databox, "导航");
            that.showlists = databox;
            that.$store.commit("gettopnavlists", databox);
            that.$store.commit("getpams", that.$route.query);
          } else {
            let message1 = that.$t("language.errmsg1");
            that.$message({
              message: message1,
              type: "error",
            });
          }
        })
        .catch(function (res) {
          let message2 = that.$t("language.errmsg2");
          that.$message({
            message: message2,
            type: "error",
          });
        });
    },
    tzindex () {
      this.$router.push({
        path: "/",
        query: {
          lang: this.$t("language.lang"),
        },
      });
      this.ismenus = false;
    },
    // 手机端
    zk (a) {
      console.log(a, "aaa");
      this.showidx = a;
    },
    showmenu () {
      let ismenus = this.ismenus;
      this.ismenus = !ismenus;
    },
    // 更改语言
    changeLang (e) {
      let temp = e.target.dataset.lang;
      // console.log(temp,'lang')
      // let locale = localStorage.getItem("locale") || "en";
      // console.log(
      //   localStorage.getItem("locale"),
      //   'localStorage.getItem("locale")',
      //   locale
      // );
      // let temp = locale === "cs" ? "en" : "cs";
      this.$i18n.locale = temp; //改变当前语言
      localStorage.locale = temp;
      this.lang = temp;
      // console.log("点击跟换语言");
      this.boxlitactiveid = "";
      if (temp == 'cs') {
        // document.title = "南京斯图加特联合展览有限公司"
        document.title = "南京斯图加特联合展览有限公司,斯图加特展览（南京）有限公司"
      } else {
        // document.title = "Nanjing Stuttgart Joint Exhibition "
        document.title = "Messe Nanjing,Nanjing Stuttgart Joint Exhibition Ltd."
      }
      this.$router.push({
        name: "index",
        query: {
          lang: temp,
        },
      });
    },

    //手机端，点击后，关闭弹窗
    gbceng () {
      this.ismenus = false;
    },
    getlogpic (a) {
      let that = this;
      this.axios
        .post("/index/index/logo", { lang: a })
        .then(function (res) {
          console.log(res, "huoqulogo12222222222");
          let data = res.data;
          if (data.status == 200) {
            that.headlogo = data.msg.img
          } else {
            let message1 = that.$t("language.errmsg1");
            that.$message({
              message: message1,
              type: "error",
            });
          }
        })
        .catch(function (res) {
          let message2 = that.$t("language.errmsg2");
          that.$message({
            message: message2,
            type: "error",
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  width: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.headerbox {
  width: 100%;
  height: 105px;
  background: url("/static/images/bk.png") right center;
  background-size: cover;
  .langchange {
    position: absolute;
    right: 10px;
    top: 12px;
    cursor: pointer;
    width: 80px;
    height: 30px;
    cursor: pointer;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      color: #000;
      font-size: 17px;
    }
    i {
      width: 2px;
      height: 65%;
      background: #000;
      display: block;
    }
    img {
      // display: block;
      width: 30px;
    }
  }
  .hd {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .hd > img {
    width: 290px;
    height: 90px;
  }
  .boxul {
    height: 105px;
    float: right;
    display: flex;
    width: 800px;
    justify-content: space-between;
  }
  .boxulli {
    padding: 0 10px;
    height: 85px;
    text-align: center;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    margin-top: 20px;
  }

  .boxlit {
    a {
      color: #000;
      font-size: 18px;
      font-weight: bold;
      position: relative;
    }
  }
  .boxulli:hover .boxlit > a {
    color: #02328d;
    &::after {
      display: block;
    }
  }
  .boxlit > a::after {
    content: "";
    display: block;
    width: 100%;
    height: 3px;
    background: #02328d;
    bottom: -10px;
    position: absolute;
    display: none;
  }
  .boxinul {
    position: absolute;
    top: 85px;
    display: flex;
    justify-content: center;
    display: none;
    color: #fff;
  }
  .boxinul li {
    white-space: nowrap;
    background: #969696;

    margin-bottom: 3px;
    cursor: pointer;
    font-size: 16px;
    a {
      display: block;
      color: #fff;
      padding: 15px 10px;
      text-align: left;
    }
  }
  .boxul {
    .boxulli {
      &:hover .boxinul {
        display: block;
      }
    }
  }
  .boxinul li a:hover {
    background: #ffea00;
    color: #02328d;
  }
  .boxlitactive a::after {
    content: "";
    display: block;
    width: 100%;
    height: 3px;
    background: #02328d;
    bottom: -10px;
    position: absolute;
  }
  .boxlitactive a {
    color: #02328d;
  }
}
@media screen and (max-width: 1200px) {
  .headerbox {
    width: 100%;
    height: 90px;
    background: url("/static/images/bk.png") right center;
    background-size: cover;
    .langchange {
      h3 {
        font-size: 17px;
      }
      img {
        width: 30px;
      }
    }
    .hd {
      width: 920px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .hd > img {
      width: 180px;
      height: auto;
      cursor: pointer;
    }
    .boxul {
      height: 90px;
      float: right;
      display: flex;
      width: 720px;
      justify-content: space-between;
    }
    .boxulli {
      padding: 0 10px;
      height: 70px;
      text-align: center;
      display: flex;
      align-items: center;
      position: relative;
      justify-content: center;
      margin-top: 20px;
    }

    .boxlit {
      a {
        color: #000;
        font-size: 16px;
        font-weight: bold;
        position: relative;
      }
    }
    .boxulli:hover .boxlit > a {
      color: #02328d;
      &::after {
        display: block;
      }
    }
    .boxlit > a::after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background: #02328d;
      bottom: -10px;
      position: absolute;
      display: none;
    }
    .boxinul {
      position: absolute;
      top: 70px;
      display: flex;
      justify-content: center;
      display: none;
      color: #fff;
    }
    .boxinul li {
      white-space: nowrap;
      background: #969696;

      margin-bottom: 3px;
      cursor: pointer;
      font-size: 14px;
      a {
        display: block;
        color: #fff;
        padding: 10px 5px;
        text-align: left;
      }
    }
    .boxul {
      .boxulli {
        &:hover .boxinul {
          display: block;
        }
      }
    }
    .boxinul li a:hover {
      background: #ffea00;
      color: #02328d;
    }
    .boxlitactive a::after {
      content: "";
      display: block;
      width: 100%;
      height: 3px;
      background: #02328d;
      bottom: -10px;
      position: absolute;
    }
    .boxlitactive a {
      color: #02328d;
    }
  }
}
.headerbox2 {
  width: 100%;
  font-size: 2vw;
  background: #fff url("/static/images/bk.png") right center;
  background-size: cover;

  .hd {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 15vw;
    .log1 {
      // width: 20vw;
      max-width: 50vw;
      max-height: 13vw;
    }
    img {
      display: block;
    }
    .btnbox {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      .langchange {
        width: 15vw;
        height: 14vw;
        display: flex;
        align-items: center;
        margin-right: 2vw;
        justify-content: space-between;
        h3 {
          color: #000;
          font-size: 4vw;
        }
        i {
          width: 2px;
          height: 4vw;
          background: #000;
          display: block;
        }
        // img {
        //   height: 7vw;
        //   display: block;
        //   margin: 0 auto;
        // }
      }
      .menubox {
        width: 10vw;
        height: 14vw;
        display: flex;
        align-items: center;
        img {
          width: 7vw;
          height: 7vw;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  .menus {
    right: -100%;
    transition: 0.5s;
  }
  .menus {
    width: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.7);
    top: 15vw;
    bottom: 0;

    .boxul {
      color: #fff;
      width: 92%;
      margin: 0 auto;
      .boxulli {
        font-size: 4vw;
        border-bottom: 1px solid #fff;
        a {
          color: #fff;
        }
        .boxinul {
          padding: 0 3vw;
          font-size: 3.8vw;
          li {
            padding: 3vw 0;
            border-bottom: 1px solid #fff;
            &:last-child {
              border-bottom: 0;
            }
          }
        }
      }
      .flexdiv {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        padding: 2vw 1vw;
        .boxlit {
          display: flex;
          align-items: center;
        }
        i {
          display: block;
          width: 7vw;
          height: 7vw;
          background: url("/static/images/right.png") no-repeat center;
          background-size: 90% 90%;
        }
      }
    }
  }
  .menusshow {
    right: 0;
    transition: 0.5s;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue